<div [style.height.vh]="68" [style.width.vw]="80">
  <gstar-editor
    [title]="data().title"
    [content]="data().content | blankLinks | safe: 'html'"
    (update)="updateHandler($event)" />
</div>
